export const COURSE_CARD_BG_COLORS = {
  stress: '#174A41',
  focus: '#808080',
  selfAwareness: '#2D127A'
};

export const HEADER_HEIGHT = '400px';
